<template>
<div class="article-w-medium-header">
    <div class="medium-header-container">
        <div class="header">{{widgetConfig.HeaderText}} </div>
        <div v-if="widgetConfig.MediumHeaderShowRedUnderline" class="divider-line"></div>
    </div>
    <div class="split-body-container">
        <div class="img-div">
            <img class="img-width" :src="widgetConfig.ImageUrl" alt="">
        </div>
        <div class="body-text">
            <span v-if="widgetConfig.BodyText"><p v-html="widgetConfig.BodyText"></p></span>
        </div>
    </div>
</div>
    
</template>

<script>
export default {
    name: "MediumHeaderSplitColumn",
    props: {
        widgetConfig: Object
    },
}
</script>

<style lang="scss" scoped>
.article-w-medium-header {
    margin: 24px 15px;
    display: flex;
    flex-direction: column;
    
    .medium-header-container{
        .header{
            display: flex;
            font-size: 26px;
            font-style: normal;
            font-weight: 300;
            line-height: 35px;
            letter-spacing: 0px;
            color: #000000;
            justify-content: center;
        }
        .divider-line {
           width: 120px;
           margin: 16px auto 24px auto;
           border-bottom: 5px solid $red-primary;
        }
    }
    .split-body-container {
        display: flex;

        .img-div {
           width: 487px;
            height: 272px;

            .img-width {
                width: 100%;
                height: 272px;
            }
        }
        .body-text {
            width: 487px;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 26px;
            color: #525656;
            margin-left: 16px;
        }
    }


    @include wide-mobile {
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        padding: 16px 0px 12px 0px;
        .medium-header-container{
            .header {
                width: 100%;
                text-align: center;
                padding:0px 24px;
            }
            .divider-line {
                border-bottom: 5px solid $red-primary;
                width: 120px;
            }
        }
        .split-body-container{
            display: flex;
            flex-direction: column;
            .img-div {
                width: 100%;
                height: 232px;
                .img-width {
                    width: 100%;
                    height: 232px;                                    
                }
            }
            .body-text {
                width: 100%; 
                margin-left: 0px;
                padding: 16px 24px 16px 24px;              
            }
            
        }
    }
}
</style>
